import { api } from '@/store/api'

import Env from '../../../env/env'

import type {
  SearchPhotoByIdRequest,
  SearchPhotoRequest,
  SearchPhotoResponse,
  UploadFaceResponse,
} from './SearchFace.types'

export const searchFaceApi = api.injectEndpoints({
  endpoints: (builder) => ({
    uploadPic: builder.mutation<UploadFaceResponse, any>({
      query: (request) => ({
        url: `${Env.REACT_APP_BASE_API_URL}/api/v1/face/upload-pic`,
        method: 'POST',
        body: request,
      }),
      transformResponse: (response: any) => {
        return response.info
      },
    }),

    searchResults: builder.mutation<SearchPhotoResponse, SearchPhotoRequest>({
      query: (request) => ({
        url: `${Env.REACT_APP_BASE_API_URL}/api/v3/face/workspaces/${request.id}/teams/${request.teamId}/search`,
        method: 'POST',
        body: {
          reportType: request.reportType,
          workspace: request.workspace,
          team: request.team,
          searchId: request.searchId,
        },
      }),
      transformResponse: (response: any) => {
        return response.info
      },
    }),

    searchResultById: builder.query<
      SearchPhotoResponse,
      SearchPhotoByIdRequest
    >({
      query: (request) => ({
        url: `${Env.REACT_APP_BASE_API_URL}/api/v1/face/face-check/${request.searchId}`,
        method: 'GET',
      }),
      transformResponse: (response: any) => {
        return response.info
      },
    }),
  }),
})

export const {
  useUploadPicMutation,
  useSearchResultsMutation,
  useLazySearchResultByIdQuery,
} = searchFaceApi
